import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faCertificate, faClipboardList, faClipboardQuestion, faLightbulb, faList, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

function FiveSHome() {
  return (
    <div className='bg-black'>
        <div className='border-b border-blue-400 mb-4'>
          <h2 className="text-xl lg:text-2xl py-2 px-4 text-yellow-200">🧹 Do 5S - Lean Workspace</h2>
        </div>
        <div className="min-h-[80vh] px-4">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 place-items-center">
            {[
              { to: "/fives-mylist", icon: faClipboardList, label: "My 5S" },
              { to: "", icon: faBookOpen, label: "5S Learning" },
              { to: "", icon: faClipboardQuestion, label: "5S Knowledge Practice" },
              { to: "", icon: faQuestionCircle, label: "5S Knowledge Test" },
              { to: "", icon: faCertificate, label: "My 5S Certificate" },
              { to: "", icon: faLightbulb, label: "5S In Action (Examples)" }
            ].map((item, index) => (
              <Link
                key={index}
                to={item.to}
                className={`
                  w-48 h-24           
                  rounded-xl shadow
                  transition duration-300 
                  flex flex-col items-center justify-center
                  text-center p-2

                  ${index === 0 
                    ? "bg-white hover:bg-gray-100"       // FIRST BOX
                    : "bg-gray-500 hover:bg-gray-600"}   // ALL OTHERS
                `}
              >
                <FontAwesomeIcon
                  icon={item.icon}
                  className={`text-2xl mb-2 
                    ${index === 0 ? "text-yellow-600" : "text-white"}
                  `}
                />
                <span className={`text-sm 
                  ${index === 0 ? "text-gray-800" : "text-white"}
                `}>
                  {item.label}
                </span>
              </Link>
            ))}
          </div>

        </div>
      <footer className="bg-black border-t border-blue-800 text-blue-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

export default FiveSHome;
